export type CheckoutActivity = {
  mode?: string | null;
  template?: string | null;
  tableBooking?: boolean | null;
  packages?: readonly unknown[] | null;
};

/**
 * Why `/$lang/$slug/checkout` cannot run for this activity, or null when it
 * can. An explore item is not bookable at all, a restaurant table is held from
 * the booking sheet on its page (free, no checkout), and an activity with no
 * package has nothing the checkout could price. All three go back to the
 * activity page rather than crash or show a checkout that cannot submit.
 */
export function checkoutBlockReason(a: CheckoutActivity | null | undefined): "explore" | "restaurant" | "no_package" | null {
  if (!a) return "no_package";
  if (a.mode === "explore") return "explore";
  // The same test the booking sheet uses for its table flow.
  if (a.tableBooking || a.template === "restaurant") return "restaurant";
  if (!a.packages || a.packages.length === 0) return "no_package";
  return null;
}
